export const dsaCompliance = `
# DSA Compliance and Labels

This application is distributed by GoSchool-AI Kft., acting in the capacity of a trader under the EU Digital Services Act.

## Labels and Markings

- No age restrictions apply to this application unless otherwise specified by the App Store.
- The app contains user-generated content uploaded by educators. All users must comply with our [Terms of Use](/terms-of-use) and affirm they have the rights to share such content.
- No hazardous, restricted, or regulated products are included in the service.

## Trader Information

GoSchool-AI Kft.  
Székhely: 1121 Budapest, Ordas köz 2.  
Email: info@goschool.ai  
VAT ID: HU32622922

## Compliance Contact

For any inquiries regarding Digital Services Act compliance, please contact us at:  
legal@goschool.ai

Effective: 30 August 2024
`
